import { Selectors as Router } from 'router';
import { State } from 'store';
import { EndpointCreator } from '../interfaces';

const tagsRE = /(\${[^}]*})/g;

/**
  @deprecated - https://github.com/SaleCycle/my-salecycle-com#legacy-code 
*/
export const getEndpoint = (state: State, endpoint: EndpointCreator, params?: { [key: string]: string }): string => {
  if (typeof endpoint === 'string') {
    return getEndpointFromString(state, endpoint, params);
  }

  return endpoint(state, params);
};

const getEndpointFromString = (state: State, endpoint: string, params?: { [key: string]: string }): string => {
  const tags = endpoint.match(tagsRE);
  if (tags == null) {
    return endpoint;
  }

  let result = endpoint;

  for (const tag of tags) {
    const key = tag.slice(2, tag.length - 1);

    if (params && params[key]) {
      result = result.replace(tag, params[key]);
      continue;
    }

    const paramFromRouter = Router.getParam(state, key);
    if (!!paramFromRouter) {
      result = result.replace(tag, paramFromRouter);
      continue;
    }

    // If we can't get the property from either the router or
    // supplied parameters, return undefined.
    return undefined;
  }

  return result;
};
